import {
    all,
    fork,
    takeEvery,
    call,
    put,
} from 'redux-saga/effects';
import { extractError } from '@iso/lib//helpers/api';
import { types, actions } from './reducer';
import WarehouseService from '@iso/services/SettingsService/WarehouseService/WarehouseService';

function* deleteWarehouse({ id }) {
    try {
        yield call(WarehouseService.deleteOne, id);
        yield put(actions.deleteWarehouseSucceeded(id));
    } catch (error) {
        yield put(actions.deleteWarehouseFailed(extractError(error)));
    }
}

function* watchDeleteWarehouse() {
    yield takeEvery(
        types.REQUEST_DELETE_WAREHOUSE,
        deleteWarehouse,
    );
}

function* deleteSaga() {
    yield all([
        fork(watchDeleteWarehouse),
    ]);
}

export default deleteSaga;
